import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getSession } from '../../getSession';
import API_ENDPOINTS from '../../config/apiEndpoints';

const WCF_BASE = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const HIERARCHY_API_URL = `${WCF_BASE}/TicketSupport/BindUsersForLeadPupup`;

/**
 * Custom hook to fetch user hierarchy display data.
 * @returns {object} - Returns { hierarchyList, loading, error, refetch }
 */
const useHierarchy = () => {
    const [hierarchyList, setHierarchyList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchHierarchy = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const { TokenId, userId } = getSession();
            
            // Fallbacks if session doesn't load fully immediately
            const token = TokenId || "-2295521862261168";
            const uid = userId || "34594";

            const payload = {
                Token: String(token),
                Details: JSON.stringify({ UserId: Number(uid) })
            };

            const response = await axios.post(HIERARCHY_API_URL, payload, {
                headers: { 'Content-Type': 'application/json' }
            });

            const data = response.data;
            const list = data?.Details?.data || data?.Details || data?.d || data || [];

            let parsedList = [];
            if (Array.isArray(list)) {
                parsedList = list;
            } else if (typeof list === 'string') {
                try {
                    parsedList = JSON.parse(list);
                } catch (e) {
                    parsedList = [];
                }
            }

            setHierarchyList(parsedList);
        } catch (err) {
            console.error('Error fetching hierarchy:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchHierarchy();
    }, [fetchHierarchy]);

    return { hierarchyList, loading, error, refetch: fetchHierarchy };
};

export default useHierarchy;
